<template>
  <transition name="slide-fade">
    <div>
      <div class="text-right">
        <b-button size="sm" variant="success" class="mt-2 mb-3" v-b-modal.customer-create>
          <i class="fas fa-plus"></i> New
        </b-button>
      </div>
      <div class="text-center w-100">
        <b-icon icon="three-dots"
                class="text-center " animation="cylon"
                font-scale="4"
                v-if="loadingStatus"></b-icon>
      </div>

      <div class="mb-3" v-if="!loadingStatus">

        <b-row>
          <b-col xl="8" lg="7" md="7" sm="12">

            <b-form-group
              label=""
              label-for="per-page-select"
              label-cols-sm="0"
              label-cols-md="0"
              label-cols-lg="0"
              label-align-sm="center"
              label-size="sm"
              class="mb-2 per-page-select"
            >
              <label for="per-page-select" class="mr-2 text-sm">Show</label>
              <b-form-select
                id="per-page-select"
                class="diameter-report-select"
                v-model="perPage"
                :options="pageOptions"
                v-on:input="changePageOption(perPage)"
                size="sm"
              ></b-form-select>
              <label for="per-page-select" class="ml-2 text-sm">entries</label>
            </b-form-group>

          </b-col>
          <b-col xl="4" lg="5" md="5" sm="12 customer-table-select">
            <b-form-group
              label=""
              label-for="filter-input"
              label-align-sm="right"
              label-size="sm "
              class="mb-0 per-page-select"
            >
              <label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input0"
                  v-model="filter"
                  placeholder="Search..."
                  class="mb-4"
                ></b-form-input>

              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-table
          striped hover
          :items="tableData"
          :fields="tableColumns"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          head-variant="light"
          table-class="text-nowrap"
          sticky-header="true"
          class="data-management-table"
          show-empty
          responsive
          small
        >
          <template #cell(action)="row">
               <span>
                    <i class="fas fa-pen-nib mr-3 cursor-pointer text-success" v-b-modal.customer-create
                       v-on:click="editCustomerInfo(row.item.customer_id)"></i>
                    <i class="fas fa-trash-alt cursor-pointer  text-danger"
                       v-on:click="deleteCustomerInfo(row.item.customer_id)"></i>
                  </span>
          </template>

        </b-table>

        <b-row class="mt-4">
          <b-col>
            <p class="ml-3"> {{ startPage }} - {{ fromPage }} of {{ totalRows }} </p>
          </b-col>
          <b-col xl="auto" md="auto" sm="auto ">
            <b-pagination
              class="flex-fill-custom pr-4 ml-3"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              v-on:input="paginationChanged(currentPage)"
              size="sm"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>

      <b-modal centered size="lg" id="customer-create" hide-footer title="Customer Information" class="customer-create"
               cancel-title="Close" ok-variant="primary" ok-title="Submit">
        <CustomerCreate></CustomerCreate>
      </b-modal>
    </div>
  </transition>
</template>

<script>
  import administratorService from "../../../../common/api-services/administrator-service";
  import CustomerCreate from "../../../Components/Add-Customer";
  import swal from 'sweetalert2';
  import handleResponse from "../../../../common/directive/handlResponse";

  export default {
    name: "CustomerList",
    components: {CustomerCreate},
    data() {
      return {
        loadingStatus: false,
        totalRows: 0,
        currentPage: 1,
        pageOptions: [10, 25, 50, 100],
        perPage: 10,
        tableColumns: [
          {key: 'customer_id', label: 'Id', sortable: true, sortDirection: 'desc'},
          {key: 'customer_group', label: 'Group', sortable: true, sortDirection: 'desc'},
          {key: 'company_name', label: 'Name', sortable: true, sortDirection: 'desc'},
          {key: 'address1', label: 'Address1', sortable: true, sortDirection: 'desc'},
          {key: 'address2', label: 'Address2', sortable: true, sortDirection: 'desc'},
          {key: 'state', label: 'State', sortable: true, sortDirection: 'desc'},
          {key: 'country', label: 'Country', sortable: true, sortDirection: 'desc'},
          {key: 'zipcode', label: 'Zip Code', sortable: true, sortDirection: 'desc'},
          {key: 'contact_name', label: 'Contact', sortable: true, sortDirection: 'desc'},
          {key: 'contact_phone', label: 'Phone', sortable: true, sortDirection: 'desc'},
          {key: 'contact_email', label: 'Email', sortable: true, sortDirection: 'desc'},
          {key: 'action', label: '#', sortable: true, sortDirection: 'desc'},

        ],
        tableData: [],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        startPage: 1,
        fromPage: 10,
        lastPage: 1,
      }
    },
    mounted() {
      this.getCustomerInfoListFunc();

      this.$root.$on('getCustomerInfo', (() => {
        this.getCustomerInfoListFunc()
      }))
    },
    methods: {
      getCustomerInfoListFunc() {
        this.loadingStatus = true;
        administratorService.getCustomerList().then(res => {
          this.loadingStatus = false;
          this.tableData = res;
          this.totalRows = this.tableData.length;
          this.paginationChanged(this.currentPage)
        })
      },

      paginationChanged(data) {
        if (data * this.perPage < this.totalRows) {
          this.fromPage = data * this.perPage;
        } else {
          this.fromPage = this.totalRows
        }

        this.currentPage = data;
        this.startPage = (this.currentPage - 1) * this.perPage + 1;

      },

      editCustomerInfo(customerId) {
        let selectedCustomer = this.tableData.find(item => item.customer_id === customerId);
        setTimeout(() => {
          this.$root.$emit('editCustomerInfo', selectedCustomer)
        }, 1000)
      },

      deleteCustomerInfo(customerId) {

        let selectedCustomer = this.tableData.find(item => item.customer_id === customerId);

        swal.fire({
          title: `Customers`,
          text: `Delete selected customer? ${selectedCustomer.company_name}`,
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,

          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          //cancelButtonClass: 'btn btn-danger',
        }).then((result) => {
          if (result.isConfirmed) {
            administratorService.deleteCustomer(customerId).then(res => {
              let {type, msg} = handleResponse.apiResponse(res);
              this.$toast(JSON.parse(msg), {type: type})
              this.getCustomerInfoListFunc();
            })
          }
        })
      },
      changePageOption(page) {
        this.getTotalRows()
      },
      getTotalRows() {
        if (this.perPage > this.totalRows) {
          this.fromPage = this.totalRows
        } else {
          this.fromPage = this.perPage
        }
      },
    }
  }
</script>

